export default {
  title: 'Marques',
  form: {
    name: {
      placeholder: 'Rechercher une marque...',
    },
  },
  fields: {
    id: '#',
    name: 'Nom',
    address: 'Adresse',
    subdomain: 'Sous-domaine',
    shop_url: 'URL de la boutique',
    companies: 'Établissements',
    slug: 'Slug',
    actions: '',
  },
  empty_list: "Aucune marque pour l'instant",
  modals: {
    delete_franchise: {
      title: 'Voulez-vous vraiment supprimer la marque {{name}} ?',
    },
  },
  buttons: {
    new_franchise: '+ Ajouter une marque',
    export_restaurants: 'Exporter les restaurants',
    edit: 'Modifier',
    delete: 'Supprimer',
    view_dashboard_as_owner: 'Voir le tableau de bord en tant que propriétaire',
    open_shop: 'Ouvrir la boutique',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_delete_franchise: 'Échec de la suppression de la marque',
    franchise_got_deleted: 'Marque supprimée',
    failed_to_create_magic_link: 'Échec de la création du lien magique',
    no_owner_to_log_in_as: 'Aucun propriétaire de restaurant avec qui se connecter',
  },
};
